import { get, post, put, del } from './apiService';

const prizeStructureService = {
  // Get all prize structures
  getPrizeStructures: async () => {
    try {
      const response = await get('admin/getprizestructures');
      return response.data || response;
    } catch (error) {
      console.error('Error fetching prize structures:', error);
      throw error;
    }
  },

  // Create a new prize structure
  createPrizeStructure: async (prizeStructureData) => {
    try {
      const response = await post('admin/createprizestructure', prizeStructureData);
      return response.data || response;
    } catch (error) {
      console.error('Error creating prize structure:', error);
      throw error;
    }
  },

  // Update an existing prize structure
  updatePrizeStructure: async (prizeStructureData) => {
    try {
      const response = await put(`admin/updateprizestructure/${prizeStructureData.id}`, prizeStructureData);
      return response.data || response;
    } catch (error) {
      console.error('Error updating prize structure:', error);
      throw error;
    }
  },

  // Delete a prize structure
  deletePrizeStructure: async (prizeStructureId) => {
    try {
      const response = await del(`admin/deleteprizestructure/${prizeStructureId}`);
      return response.data || response;
    } catch (error) {
      console.error('Error deleting prize structure:', error);
      throw error;
    }
  }
};

export default prizeStructureService;
